import { render, staticRenderFns } from "./MoveDownIcon.vue?vue&type=template&id=c73226aa"
import script from "./MoveDownIcon.vue?vue&type=script&lang=js"
export * from "./MoveDownIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports